import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// const IDLE_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes // Defined 1 min IDE Window Timeout
const IDLE_TIMEOUT_MS = 7 * 24 * 60 * 60 * 1000; // 7 days


export default function IdleLogout() {
  const navigate = useNavigate();
  const location = useLocation();
  const timerRef = useRef(null);

  useEffect(() => {
    function isAuthed() {
      try { return localStorage.getItem('auth') === 'true'; } catch (e) { return false; }
    }

    function clearAuthAndRedirect() {
      try { localStorage.removeItem('auth'); } catch (e) {}
      if (window.showPreloader) { window.showPreloader(); }
      navigate('/', { replace: true });
    }

    function resetTimer() {
      if (!isAuthed()) return; // only enforce when logged in
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => {
        clearAuthAndRedirect();
      }, IDLE_TIMEOUT_MS);
    }

    const activityEvents = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    activityEvents.forEach((evt) => window.addEventListener(evt, resetTimer, { passive: true }));

    // Start/stop the timer when route changes as well
    resetTimer();

    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      activityEvents.forEach((evt) => window.removeEventListener(evt, resetTimer));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, location.pathname]);

  return null;
}


